import React from 'react';
import PropTypes from 'prop-types';
import ArticleThumbnail from "./ArticleThumbnail";

const ArticleThumbnailList = props => {
    return (
        props.articleList.map(item => (
            <ArticleThumbnail data={item} key={`articleThumb-${item.id}`}
                              openArticle={props.openArticle} hover={props.hover}/>
        ))
    )
};

ArticleThumbnailList.propTypes = {
    articleList: PropTypes.array.isRequired,
    openArticle: PropTypes.func.isRequired
};

export default ArticleThumbnailList;
